import { ResponseStatusEnum } from "../../../helpers/GlobalEnum";
import { alertedProductsServices } from "../../../helpers/services/AlertedProductsServices";

// Detalle de centralización de un producto alertado. Alimenta las secciones
// "Información de orden de compra" y "Gestión de levantamiento" del detalle
// (GET /api/alertas/centralizacion?orden_detalle_id=).
const normalizeCentralizacionDetalle = (data = {}) => {
  const ordenCompra = data?.orden_compra ?? {};
  const gestion = data?.gestion_levantamiento ?? {};

  return {
    ordenCompra: {
      numeroOrden: ordenCompra?.numero_orden ?? "",
      fecha: ordenCompra?.fecha ?? "",
      idProducto: ordenCompra?.id_producto ?? "",
      productosAlertados: ordenCompra?.productos_alertados ?? "",
    },
    gestionLevantamiento: {
      estado: gestion?.estado ?? "",
      fechaSolicitud: gestion?.fecha_solicitud ?? "",
      fechaVobo: gestion?.fecha_vobo ?? "",
      observacionRevision: gestion?.observacion_revision ?? "",
      rolResponsable: gestion?.rol_responsable ?? "",
      tipoGestion: gestion?.tipo_gesion ?? gestion?.tipo_gestion ?? "",
      usuarioImplementacion: gestion?.usuario_implementacion ?? "",
    },
  };
};

export const getAlertedProductsCentralizacion = async (ordenDetalleId) => {
  const response = await alertedProductsServices.getCentralizacion(ordenDetalleId);

  if (response?.status !== ResponseStatusEnum.OK) {
    throw response;
  }

  return normalizeCentralizacionDetalle(response?.data ?? {});
};